import React from "react";
import { format } from "date-fns";
import { UTCDateMini } from "@date-fns/utc/date/mini";
import { twMerge } from "tailwind-merge";
import { SupAttributeBadge, SupText, SupTracker } from "@repo/core-ui";

import { SupTxFormattedValue } from "../TxFormattedValue";
import type { TxStatus } from "../types";

export interface TxItemProps {
  className?: string;
  status: TxStatus;
  type: "deposit" | "withdrawal";
  hash: string;
  timestamp: number;
  superformIds: string[];
  onCopy?: (value: string) => void;
}

export const statusColors = {
  confirmed: "success",
  processing: "info",
  stuck: "warning",
  reverted: "error",
  skipped: "primary-active",
} as const;

export function SupTxItem({ className, status, timestamp, hash, type, superformIds, onCopy }: TxItemProps) {
  const txCount = superformIds.length;

  return (
    <div className={twMerge("flex flex-col p-4 gap-4", className)}>
      <div className="flex items-center justify-between">
        <SupTracker variant={statusColors[status]}>{status}</SupTracker>
        <SupAttributeBadge attribute={txCount} label={type} color="primary" />
      </div>

      <SupText as="div" variant="button" className="flex gap-1">
        <SupTxFormattedValue value={hash} formatter={hash => `${hash.substring(0, 5)}...${hash.substring(hash.length - 7, hash.length)}`} onCopy={onCopy} />
      </SupText>

      <SupText variant="caption" as="div">
        {format(new UTCDateMini(timestamp), "MMMM d y, KK:mm:ss aa O")}
      </SupText>
    </div>
  );
}
